import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramClinicsPage } from './program-clinics';
import { DirectivesModule } from '../../directives/directives.module';
import { MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule } from '@angular/material';

@NgModule({
  declarations: [
    ProgramClinicsPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramClinicsPage),
    DirectivesModule,
    MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule
  ],
})
export class ProgramClinicsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-clinics/program-clinics.module.ts